import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import WidgetPage from './pages/WidgetPage.js';
import PaymentPage from './pages/PaymentPage.js';
import PaymentExpiredPage from './pages/PaymentExpiredPage.js';
import PaymentSuccessPage from './pages/PaymentSuccessPage.js';
import OnmetaWidgetPage from './pages/OnmetaWidgetPage.js';
import './App.css';

function App() {
  return (
    <Routes>
      {/* Root redirects to widget */}
      <Route path="/" element={<Navigate to="/widget" replace />} />

      {/* Standalone Widget Route */}
      <Route path="/widget" element={<WidgetPage />} />

      {/* Secure Payment Pages */}
      <Route path="/pay/:token" element={<PaymentPage />} />
      <Route path="/pay/expired" element={<PaymentExpiredPage />} />
      <Route path="/payment/success" element={<PaymentSuccessPage />} />
      <Route path="/onmeta-widget" element={<OnmetaWidgetPage />} />

      {/* Fallback - redirect to widget */}
      <Route path="*" element={<Navigate to="/widget" replace />} />
    </Routes>
  );
}

export default App;
